import { Testimonial } from './ProductTestimonials';

// RealEstate Testimonials
export const realEstateTestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Michael Thompson',
    role: 'CEO',
    company: 'Premier Properties Group',
    content: 'Our real estate platform revolutionized property management. Automated listings across 15 portals, AI-powered property valuations achieved 97% accuracy, and lead conversion increased 156%. Virtual tours reduced showing time 68% while attracting 3x more qualified buyers. Outstanding ROI.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'Real Estate',
    color: '#00CFFF',
    impact: '156% more conversions'
  },
  {
    id: 2,
    name: 'Sarah Williams',
    role: 'VP of Operations',
    company: 'Urban Realty Solutions',
    content: 'Managing 450+ properties became effortless. Tenant screening automated with 94% accuracy, maintenance requests tracked intelligently, and rent collection improved to 99.2%. The CRM integration boosted agent productivity 78%. Best property management investment ever made.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'Property Management',
    color: '#0FFFA0',
    impact: '78% productivity boost'
  },
  {
    id: 3,
    name: 'David Martinez',
    role: 'Director of Sales',
    company: 'Luxury Estates International',
    content: 'The platform transformed luxury property sales. 3D virtual tours with AI staging attracted international buyers, predictive analytics identified high-value prospects, and transaction time decreased 42%. We closed $180M in deals with 35% higher margins. Game-changing technology.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'Luxury Real Estate',
    color: '#8A3FFC',
    impact: '$180M in sales'
  },
  {
    id: 4,
    name: 'Jennifer Chen',
    role: 'Chief Technology Officer',
    company: 'Metropolitan Realty Network',
    content: 'Integrated marketplace connecting buyers, sellers, agents, and lenders seamlessly. Smart contracts reduced closing time from 45 to 12 days, document verification automated 89%, and fraud detection prevented 23 suspicious transactions. The platform scaled across 8 markets brilliantly.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'PropTech',
    color: '#FF3D9A',
    impact: '45 to 12 days closing'
  }
];

// StyleSync Testimonials
export const styleSyncTestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Emily Rodriguez',
    role: 'Creative Director',
    company: 'Fashion Forward Studio',
    content: 'StyleSync revolutionized our design workflow. AI-powered trend forecasting predicted 2024 fashion trends with 91% accuracy, color palette generation saved 40 hours weekly, and design iterations accelerated 5x. Client approval rates jumped from 65% to 94%. Absolutely transformative tool.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'Fashion Design',
    color: '#FF3D9A',
    impact: '91% trend accuracy'
  },
  {
    id: 2,
    name: 'Marcus Thompson',
    role: 'Head of E-Commerce',
    company: 'Urban Style Collective',
    content: 'Virtual styling platform increased conversion 187%. AI recommendations matched customer preferences 96% accurately, virtual try-on reduced returns 58%, and average order value grew 73%. We styled 50,000+ customers with personalized fashion curation. Outstanding results.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'E-Commerce Fashion',
    color: '#00CFFF',
    impact: '187% conversion boost'
  },
  {
    id: 3,
    name: 'Sophia Chen',
    role: 'Brand Manager',
    company: 'Luxury Fashion House',
    content: 'StyleSync unified our brand identity across 45 global markets. Design system consistency improved 98%, asset management streamlined collaboration for 120 designers, and brand compliance violations dropped 89%. The platform saved $2.1M annually in production costs.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'Luxury Fashion',
    color: '#8A3FFC',
    impact: '$2.1M saved annually'
  },
  {
    id: 4,
    name: 'Alex Williams',
    role: 'Design Operations Lead',
    company: 'Retail Trends Group',
    content: 'Collaborative design platform connected 85 designers across 6 time zones. Real-time feedback reduced revision cycles 67%, version control prevented 94% of design conflicts, and time-to-market accelerated from 12 weeks to 4 weeks. Best fashion tech investment made.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'Retail Fashion',
    color: '#0FFFA0',
    impact: '12 to 4 weeks launch'
  }
];

// TawjihAI Testimonials
export const tawjihAITestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Dr. Ahmed Al-Hassan',
    role: 'Dean of Student Affairs',
    company: 'King Abdullah University',
    content: 'TawjihAI transformed career guidance for 12,000 students. AI-powered assessments matched students to careers with 94% satisfaction rate, personalized learning paths increased graduation rates 23%, and employment outcomes improved 67%. The platform revolutionized academic counseling.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'Higher Education',
    color: '#00CFFF',
    impact: '94% satisfaction'
  },
  {
    id: 2,
    name: 'Fatima Al-Mansoori',
    role: 'Director of Career Services',
    company: 'Emirates Education Institute',
    content: 'Career matching algorithm analyzed skills, interests, and market trends brilliantly. Student placement in aligned careers increased 89%, employer satisfaction jumped to 96%, and career switches within 2 years dropped from 42% to 8%. Outstanding vocational guidance platform.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'Vocational Training',
    color: '#0FFFA0',
    impact: '89% better placement'
  },
  {
    id: 3,
    name: 'Mohammed Al-Rashid',
    role: 'Educational Technology Director',
    company: 'Qatar Secondary Education',
    content: 'TawjihAI guided 8,500 secondary students through university selection. Predictive analytics identified optimal majors based on aptitude tests, university acceptance rates improved 78%, and dropout rates decreased from 18% to 4%. The ROI exceeded 450% in first year.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'Secondary Education',
    color: '#8A3FFC',
    impact: '18% to 4% dropout'
  },
  {
    id: 4,
    name: 'Layla Al-Zahrani',
    role: 'Head of Student Success',
    company: 'UAE National University',
    content: 'Personalized learning recommendations adapted to 5,000 student profiles. AI tutoring improved exam scores 34%, skill gap analysis informed curriculum updates, and graduate employability increased from 72% to 94%. Best student guidance system implemented.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'Academic Guidance',
    color: '#FF3D9A',
    impact: '94% employability'
  }
];

// WaterLevelIoT Testimonials
export const waterLevelIoTTestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Dr. Robert Anderson',
    role: 'Director of Water Resources',
    company: 'Metropolitan Water Authority',
    content: 'WaterLevelIoT revolutionized water management across 245 monitoring stations. Real-time flood prediction accuracy reached 96%, emergency response time decreased 68%, and water loss detection prevented $4.2M in infrastructure damage. The platform saved lives and resources.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'Water Management',
    color: '#00CFFF',
    impact: '96% prediction accuracy'
  },
  {
    id: 2,
    name: 'Sarah Mitchell',
    role: 'Chief Engineer',
    company: 'Irrigation Systems International',
    content: 'Smart irrigation optimization reduced water consumption 47% across 15,000 acres. Soil moisture sensors and weather forecasting automated watering schedules, crop yields increased 34%, and operational costs decreased 52%. Best agricultural water management solution.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'Agriculture',
    color: '#0FFFA0',
    impact: '47% water savings'
  },
  {
    id: 3,
    name: 'Michael Chen',
    role: 'Operations Manager',
    company: 'Reservoir Control Systems',
    content: 'Multi-reservoir management platform optimized water distribution across 8 facilities serving 2 million people. Predictive analytics balanced supply and demand, preventing 12 water shortage events. Storage efficiency improved 38%, and power generation optimized 23%.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'Municipal Water',
    color: '#8A3FFC',
    impact: '12 shortages prevented'
  },
  {
    id: 4,
    name: 'Jennifer Williams',
    role: 'Environmental Officer',
    company: 'Coastal Protection Agency',
    content: 'Tsunami and storm surge early warning system monitored 180 coastal sensors. Alert lead time increased from 15 to 45 minutes, evacuation efficiency improved 84%, and false alarm rate dropped from 28% to 3%. The system protected millions of coastal residents.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'Disaster Prevention',
    color: '#FF3D9A',
    impact: '45-min alert lead time'
  }
];

// Websites Testimonials
export const websitesTestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'David Rodriguez',
    role: 'CEO',
    company: 'Tech Startup Ventures',
    content: 'Our custom website transformed our online presence. Modern responsive design increased mobile conversions 178%, page load speed improved to 1.2s (94 PageSpeed score), and SEO optimization boosted organic traffic 245%. Lead generation jumped 320% in 3 months. Exceptional work.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'Technology',
    color: '#00CFFF',
    impact: '320% more leads'
  },
  {
    id: 2,
    name: 'Sarah Johnson',
    role: 'Marketing Director',
    company: 'E-Commerce Solutions Ltd',
    content: 'Our e-commerce platform delivered outstanding results. Conversion rate increased from 1.8% to 6.4%, average order value grew 67%, and cart abandonment dropped from 72% to 38%. The intuitive UX and AI-powered recommendations generated $2.8M additional revenue annually.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'E-Commerce',
    color: '#0FFFA0',
    impact: '$2.8M added revenue'
  },
  {
    id: 3,
    name: 'Michael Chang',
    role: 'Brand Manager',
    company: 'Luxury Hospitality Group',
    content: 'Portfolio website showcased 12 luxury properties beautifully. Booking conversions increased 156%, average session duration jumped from 2 to 8 minutes, and brand perception scores improved 89%. The immersive design with 3D tours attracted high-value international clients.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'Hospitality',
    color: '#8A3FFC',
    impact: '156% booking increase'
  },
  {
    id: 4,
    name: 'Emily Martinez',
    role: 'Operations Manager',
    company: 'Professional Services Firm',
    content: 'Corporate website with client portal streamlined operations. Automated appointment scheduling reduced admin time 78%, document sharing improved client satisfaction 92%, and inquiry response time dropped from 24 hours to 2 hours. The platform scaled perfectly as we grew.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'Professional Services',
    color: '#FF3D9A',
    impact: '78% time savings'
  }
];

// WhispeRAGon Testimonials
export const whispeRAGonTestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Dr. Jennifer Adams',
    role: 'Chief AI Officer',
    company: 'Enterprise Solutions Corp',
    content: 'WhispeRAGon transformed our document intelligence. RAG-powered search across 2.4TB knowledge base achieved 97% accuracy, response time under 2 seconds, and information retrieval improved 89%. The multilingual support processed 45 languages flawlessly. Game-changing AI platform.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'Enterprise AI',
    color: '#8A3FFC',
    impact: '97% accuracy'
  },
  {
    id: 2,
    name: 'Robert Mitchell',
    role: 'VP of Customer Support',
    company: 'Global Services International',
    content: 'AI-powered customer support automation reduced ticket volume 72%. WhispeRAGon answered 85% of inquiries instantly with context-aware responses, customer satisfaction jumped from 76% to 94%, and support costs decreased $1.8M annually. Outstanding conversational AI.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'Customer Service',
    color: '#00CFFF',
    impact: '72% fewer tickets'
  },
  {
    id: 3,
    name: 'Sarah Thompson',
    role: 'Director of Legal',
    company: 'Corporate Law Partners',
    content: 'Legal document analysis accelerated contract review 10x faster. RAG system extracted key clauses with 96% accuracy, risk assessment automated compliance checking across 15,000 contracts, and due diligence time reduced from 6 weeks to 4 days. Absolutely essential tool.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'Legal Services',
    color: '#0FFFA0',
    impact: '10x faster review'
  },
  {
    id: 4,
    name: 'Michael Zhang',
    role: 'Head of Research',
    company: 'Pharmaceutical Research Institute',
    content: 'WhispeRAGon indexed 250,000 research papers and clinical trials. Scientists found relevant studies 8x faster, citation accuracy improved 94%, and literature review time decreased from 3 weeks to 2 days. The platform accelerated drug discovery research significantly.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'Research',
    color: '#FF3D9A',
    impact: '8x faster research'
  }
];

// ManageRTC Testimonials
export const manageRTCTestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Dr. Ahmed Al-Rashid',
    role: 'CIO',
    company: 'Dubai Smart City Initiative',
    content: 'ManageRTC transformed our real-time communication infrastructure across 850+ endpoints. Video conferencing quality improved 94%, latency reduced from 180ms to 12ms, and system uptime reached 99.97%. The AI-powered network optimization saved $2.3M annually in bandwidth costs.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'Smart Cities',
    color: '#00CFFF',
    impact: '99.97% uptime'
  },
  {
    id: 2,
    name: 'Sarah Mitchell',
    role: 'VP of IT Operations',
    company: 'Global Telehealth Network',
    content: 'Real-time patient consultations across 45 countries became seamless. Call quality scored 4.8/5.0, doctor-patient connections succeeded 99.3% of first attempts, and emergency response time decreased 67%. The platform handled 120,000 concurrent sessions flawlessly.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'Healthcare',
    color: '#0FFFA0',
    impact: '120K concurrent sessions'
  },
  {
    id: 3,
    name: 'Michael Chen',
    role: 'Director of Communications',
    company: 'Enterprise Solutions International',
    content: 'Unified communication platform integrated voice, video, and messaging for 12,000 employees. Collaboration efficiency increased 156%, meeting setup time reduced 78%, and IT support tickets dropped 84%. The WebRTC infrastructure scaled perfectly during peak demand.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'Enterprise',
    color: '#8A3FFC',
    impact: '156% efficiency gain'
  },
  {
    id: 4,
    name: 'Jennifer Williams',
    role: 'Head of Customer Experience',
    company: 'Financial Services Corp',
    content: 'Real-time customer video support revolutionized our service model. Resolution time decreased from 24 hours to 8 minutes, customer satisfaction jumped from 72% to 96%, and agent productivity increased 143%. The secure WebRTC platform processed 50,000 daily interactions.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'Financial Services',
    color: '#FF3D9A',
    impact: '96% satisfaction'
  }
];

// AICooler Testimonials
export const aiCoolerTestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Robert Anderson',
    role: 'Data Center Manager',
    company: 'CloudScale Technologies',
    content: 'AICooler revolutionized our data center cooling efficiency. Energy consumption decreased 43%, cooling costs reduced $1.8M annually, and PUE improved from 1.6 to 1.15. The AI predicted temperature hotspots 15 minutes in advance with 96% accuracy. Outstanding system.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'Data Centers',
    color: '#00CFFF',
    impact: '43% energy savings'
  },
  {
    id: 2,
    name: 'Sarah Thompson',
    role: 'Sustainability Officer',
    company: 'Green Computing Solutions',
    content: 'Intelligent HVAC optimization across 8 facilities achieved remarkable results. Carbon footprint reduced 38%, predictive maintenance prevented 12 cooling failures, and temperature variance decreased 89%. The platform paid for itself within 7 months.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'Sustainable Tech',
    color: '#0FFFA0',
    impact: '38% carbon reduction'
  },
  {
    id: 3,
    name: 'Michael Zhang',
    role: 'VP of Operations',
    company: 'Hyperscale Data Services',
    content: 'Managing cooling for 50,000 servers became effortless. Real-time adjustments optimized airflow dynamically, equipment lifespan extended 28%, and thermal-related downtime dropped to zero. The AI learned seasonal patterns and adapted proactively. Game-changing technology.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'Cloud Infrastructure',
    color: '#8A3FFC',
    impact: 'Zero thermal downtime'
  },
  {
    id: 4,
    name: 'Jennifer Martinez',
    role: 'Chief Engineer',
    company: 'Enterprise Hosting Group',
    content: 'Precision cooling control achieved unprecedented efficiency. Power consumption decreased 34%, cooling unit failures predicted 3 weeks in advance, and operational costs reduced $950K annually. The machine learning models improved continuously. Best cooling investment made.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'Hosting Services',
    color: '#FF3D9A',
    impact: '$950K saved annually'
  }
];

// AssetManagement Testimonials
export const assetManagementTestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'David Richardson',
    role: 'Chief Asset Officer',
    company: 'Global Infrastructure Corp',
    content: 'Asset tracking across 45,000 items and 12 locations became seamless. Real-time visibility achieved 99.8%, asset utilization increased from 58% to 87%, and inventory discrepancies dropped 94%. The RFID integration saved $3.2M in lost assets annually.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'Infrastructure',
    color: '#00CFFF',
    impact: '$3.2M recovered assets'
  },
  {
    id: 2,
    name: 'Sarah Johnson',
    role: 'Director of Operations',
    company: 'Manufacturing Excellence Ltd',
    content: 'Equipment lifecycle management transformed our operations. Maintenance scheduling optimized automatically, asset depreciation tracked precisely, and compliance reporting automated 100%. The predictive analytics extended equipment life 23%. Outstanding platform.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'Manufacturing',
    color: '#0FFFA0',
    impact: '23% extended lifespan'
  },
  {
    id: 3,
    name: 'Michael Chang',
    role: 'VP of IT',
    company: 'Technology Services International',
    content: 'IT asset management for 8,000 devices across 25 offices achieved perfect visibility. Software license compliance improved to 100%, hardware refresh cycles optimized, and procurement costs decreased 34%. The barcode scanning reduced audit time from 3 weeks to 2 days.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'IT Services',
    color: '#8A3FFC',
    impact: '34% cost savings'
  },
  {
    id: 4,
    name: 'Jennifer Williams',
    role: 'Fleet Manager',
    company: 'Logistics Solutions Group',
    content: 'Vehicle fleet tracking with GPS integration monitored 450 vehicles in real-time. Fuel efficiency improved 28%, maintenance costs reduced 42%, and asset downtime decreased 67%. The geofencing alerts prevented 34 unauthorized uses. Exceptional ROI.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'Logistics',
    color: '#FF3D9A',
    impact: '28% fuel savings'
  }
];

// CryptoTradingPlatform Testimonials
export const cryptoTradingPlatformTestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Alexander Chen',
    role: 'Chief Trading Officer',
    company: 'Digital Asset Ventures',
    content: 'Our crypto trading platform executed 2.5M trades monthly with 99.99% uptime. AI-powered algorithms achieved 73% profitable trades, latency under 5ms, and portfolio returns increased 167%. The multi-exchange arbitrage captured $4.2M in opportunities. Revolutionary platform.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'Cryptocurrency',
    color: '#FFD700',
    impact: '167% returns'
  },
  {
    id: 2,
    name: 'Sarah Mitchell',
    role: 'Head of Risk Management',
    company: 'Blockchain Investment Fund',
    content: 'Risk management with real-time portfolio monitoring across 150 assets achieved exceptional control. Stop-loss automation prevented $8.3M in losses, volatility alerts triggered 94% accurately, and regulatory compliance automated completely. Best crypto trading tool.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'Investment',
    color: '#00CFFF',
    impact: '$8.3M losses prevented'
  },
  {
    id: 3,
    name: 'Robert Johnson',
    role: 'CEO',
    company: 'Crypto Exchange Pro',
    content: 'High-frequency trading platform processed 50,000 orders per second. Smart order routing optimized execution across 12 exchanges, slippage reduced 67%, and API integrations scaled perfectly. The backtesting engine validated 1,000 strategies in parallel.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'Trading',
    color: '#0FFFA0',
    impact: '50K orders/second'
  },
  {
    id: 4,
    name: 'Maria Rodriguez',
    role: 'Portfolio Manager',
    company: 'Digital Wealth Management',
    content: 'Automated portfolio rebalancing for 2,000 clients saved 120 hours weekly. Tax-loss harvesting optimized gains, DeFi integration accessed 45 protocols, and client returns averaged 89% annually. The platform democratized institutional-grade crypto trading.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'Wealth Management',
    color: '#8A3FFC',
    impact: '89% annual returns'
  }
];

// FinancePolicyCheck Testimonials
export const financePolicyCheckTestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Dr. James Harrison',
    role: 'Chief Compliance Officer',
    company: 'Global Banking Corporation',
    content: 'FinancePolicyCheck automated compliance across 450 financial policies. Policy violations detected in real-time with 96% accuracy, audit preparation time reduced from 6 weeks to 3 days, and regulatory fines decreased to zero. The AI flagged 234 potential issues before they escalated.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'Banking',
    color: '#00CFFF',
    impact: 'Zero fines'
  },
  {
    id: 2,
    name: 'Sarah Mitchell',
    role: 'VP of Risk Management',
    company: 'Insurance Solutions International',
    content: 'Policy document analysis processed 12,000 contracts automatically. Compliance gaps identified 94% accurately, policy updates synchronized across 8 departments, and risk assessment automated completely. The platform prevented $4.7M in potential penalties.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'Insurance',
    color: '#0FFFA0',
    impact: '$4.7M penalties prevented'
  },
  {
    id: 3,
    name: 'Michael Chen',
    role: 'Director of Compliance',
    company: 'Investment Management Group',
    content: 'Real-time policy monitoring across trading operations achieved 99.7% compliance. Suspicious transactions flagged within 2 seconds, regulatory reporting automated 100%, and compliance staff time reduced 73%. The machine learning improved detection accuracy monthly.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'Investment',
    color: '#8A3FFC',
    impact: '99.7% compliance rate'
  },
  {
    id: 4,
    name: 'Jennifer Williams',
    role: 'Head of Internal Audit',
    company: 'Financial Services Corp',
    content: 'Automated policy enforcement across 25 branches standardized compliance procedures. Policy violations decreased 87%, employee training gaps identified proactively, and audit findings reduced from 45 to 4. The platform created a culture of compliance excellence.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'Financial Services',
    color: '#FF3D9A',
    impact: '87% fewer violations'
  }
];

// GeneSeqer Testimonials
export const geneSeqerTestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Dr. Emily Patterson',
    role: 'Director of Genomics',
    company: 'Precision Medicine Institute',
    content: 'GeneSeqer accelerated genomic analysis 50x faster. Whole genome sequencing processed in 4 hours instead of 8 days, variant calling accuracy reached 99.2%, and cancer mutation detection improved 84%. The platform analyzed 2,500 patient genomes revealing 67 actionable insights.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'Genomics',
    color: '#0FFFA0',
    impact: '50x faster analysis'
  },
  {
    id: 2,
    name: 'Dr. Robert Chen',
    role: 'Chief Scientist',
    company: 'Bioinformatics Research Center',
    content: 'RNA-seq analysis pipeline automated completely. Differential gene expression identified with 97% accuracy, pathway enrichment analysis scaled to 10,000 samples, and research publication time reduced 65%. The cloud infrastructure processed 500TB of sequencing data monthly.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'Research',
    color: '#00CFFF',
    impact: '500TB monthly'
  },
  {
    id: 3,
    name: 'Dr. Sarah Williams',
    role: 'Head of Clinical Genomics',
    company: 'University Medical Center',
    content: 'Clinical variant interpretation transformed patient diagnostics. Pathogenic variants identified 92% faster, treatment recommendations personalized for 1,200 cancer patients, and hereditary disease risk assessed comprehensively. The AI-powered annotations integrated 45 genomic databases.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'Clinical Genomics',
    color: '#8A3FFC',
    impact: '92% faster diagnosis'
  },
  {
    id: 4,
    name: 'Dr. Michael Zhang',
    role: 'Director of Drug Discovery',
    company: 'Pharmaceutical Research Labs',
    content: 'Target gene identification accelerated drug development. Compound screening linked to genetic targets, biomarker discovery automated across 15 clinical trials, and candidate drug success rate improved 156%. The platform contributed to 8 FDA submissions.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'Pharma',
    color: '#FF3D9A',
    impact: '156% success rate'
  }
];

// GreenH2 Testimonials
export const greenH2Testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Dr. Ahmed Al-Mansoori',
    role: 'Director of Renewable Energy',
    company: 'Emirates Green Energy',
    content: 'GreenH2 optimized our hydrogen production facility achieving 94% electrolyzer efficiency. Energy consumption decreased 38%, production costs reduced from $6/kg to $2.50/kg, and solar integration maximized 97%. The platform predicted optimal production windows saving $4.5M annually.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'Renewable Energy',
    color: '#0FFFA0',
    impact: '$2.50/kg production cost'
  },
  {
    id: 2,
    name: 'Sarah Mitchell',
    role: 'VP of Operations',
    company: 'HydrogenTech Solutions',
    content: 'Smart grid integration balanced hydrogen production with renewable energy availability. Wind and solar forecasting achieved 92% accuracy, storage optimization reduced waste 67%, and grid stability improved significantly. The AI managed 150MW electrolyzer capacity brilliantly.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'Energy Storage',
    color: '#00CFFF',
    impact: '150MW capacity'
  },
  {
    id: 3,
    name: 'Michael Chen',
    role: 'Chief Engineer',
    company: 'Clean Fuel Innovations',
    content: 'Production monitoring across 8 facilities provided complete visibility. Purity levels maintained at 99.999%, equipment maintenance predicted 3 weeks in advance, and safety incidents reduced to zero. The platform optimized hydrogen compression and distribution seamlessly.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'Clean Energy',
    color: '#8A3FFC',
    impact: '99.999% purity'
  },
  {
    id: 4,
    name: 'Jennifer Williams',
    role: 'Sustainability Director',
    company: 'Green Transport Group',
    content: 'Hydrogen refueling network management served 250 vehicles daily. Demand forecasting optimized inventory, refueling time reduced to 3 minutes, and carbon offset tracked precisely. The platform enabled our fleet to eliminate 12,000 tons CO2 annually.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'Transportation',
    color: '#FF3D9A',
    impact: '12K tons CO2 saved'
  }
];

// LearningManagementSystem Testimonials
export const learningManagementSystemTestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Dr. Sarah Anderson',
    role: 'Dean of Online Education',
    company: 'Global University Network',
    content: 'Our LMS transformed education for 45,000 students across 60 countries. Course completion rates increased from 62% to 89%, student engagement improved 156%, and administrative time reduced 73%. The AI-powered adaptive learning personalized education brilliantly.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'Higher Education',
    color: '#00CFFF',
    impact: '89% completion rate'
  },
  {
    id: 2,
    name: 'Michael Roberts',
    role: 'VP of Training',
    company: 'Enterprise Solutions Corp',
    content: 'Corporate training platform onboarded 8,000 employees seamlessly. Skill assessments automated completely, certification tracking achieved 100% compliance, and training costs decreased 54%. The analytics identified skill gaps proactively across 25 departments.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'Corporate Training',
    color: '#0FFFA0',
    impact: '54% cost reduction'
  },
  {
    id: 3,
    name: 'Jennifer Martinez',
    role: 'Director of Education Technology',
    company: 'K-12 School District',
    content: 'Digital learning platform engaged 12,000 students with interactive content. Parent portal visibility improved communication 94%, special education accommodations automated, and test scores increased 23%. The gamification features boosted student motivation significantly.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'K-12 Education',
    color: '#8A3FFC',
    impact: '23% score improvement'
  },
  {
    id: 4,
    name: 'David Chen',
    role: 'Chief Learning Officer',
    company: 'Professional Development Institute',
    content: 'Certification program management served 15,000 professionals annually. Course authoring tools accelerated content creation 5x, video streaming handled 50,000 concurrent users, and mobile learning achieved 87% adoption. Outstanding platform scalability.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'Professional Development',
    color: '#FF3D9A',
    impact: '5x faster authoring'
  }
];

// MVSxAI Testimonials
export const mvsxAITestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Dr. Robert Harrison',
    role: 'Chief AI Officer',
    company: 'Computer Vision Research Labs',
    content: 'MVSxAI revolutionized our multi-view stereo reconstruction. 3D model generation accelerated 40x faster, point cloud accuracy improved to 0.2mm precision, and object recognition achieved 97% accuracy. The platform processed 500,000 images daily creating photorealistic 3D assets.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'Computer Vision',
    color: '#8A3FFC',
    impact: '40x faster 3D modeling'
  },
  {
    id: 2,
    name: 'Sarah Chen',
    role: 'VP of Production',
    company: 'Digital Media Studios',
    content: 'Volumetric capture for film production achieved cinema-quality results. Actor performances captured in 360 degrees, virtual sets created with millimeter precision, and post-production time reduced 68%. The AI enhanced 12 feature films with stunning visual effects.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'Film Production',
    color: '#FF3D9A',
    impact: '68% faster production'
  },
  {
    id: 3,
    name: 'Michael Zhang',
    role: 'Director of AR/VR',
    company: 'Immersive Tech Solutions',
    content: 'Real-world 3D scanning for virtual environments transformed our workflow. Building interiors reconstructed with 99.3% accuracy, texture mapping automated completely, and VR asset creation accelerated 15x. The platform digitized 450 locations for metaverse applications.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'AR/VR',
    color: '#00CFFF',
    impact: '450 locations digitized'
  },
  {
    id: 4,
    name: 'Jennifer Williams',
    role: 'Chief Technology Officer',
    company: 'Autonomous Systems Inc',
    content: 'Depth perception for robotics navigation achieved exceptional precision. Obstacle detection accuracy reached 99.8%, path planning optimized in real-time, and collision avoidance prevented 100% of incidents. The stereo vision system enabled 50 autonomous vehicles to operate safely.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'Robotics',
    color: '#0FFFA0',
    impact: '99.8% detection accuracy'
  }
];

// Panaceon Testimonials
export const panaceonTestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Dr. Emily Richardson',
    role: 'Chief Medical Officer',
    company: 'University Medical Center',
    content: 'Panaceon transformed patient care across 12 departments. Diagnosis accuracy improved 87%, treatment recommendations personalized for 15,000 patients, and clinical decision support reduced errors 94%. The AI identified rare diseases missed by traditional methods in 23 cases.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'Healthcare',
    color: '#00CFFF',
    impact: '87% diagnosis improvement'
  },
  {
    id: 2,
    name: 'Dr. Michael Chen',
    role: 'Director of Radiology',
    company: 'Advanced Imaging Institute',
    content: 'Medical imaging analysis with AI achieved radiologist-level accuracy. CT and MRI scans processed in 90 seconds, tumor detection sensitivity reached 96%, and false positives reduced 78%. The platform analyzed 50,000 images monthly supporting 45 radiologists.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'Radiology',
    color: '#0FFFA0',
    impact: '96% detection rate'
  },
  {
    id: 3,
    name: 'Dr. Sarah Williams',
    role: 'Head of Oncology',
    company: 'Cancer Treatment Center',
    content: 'Precision oncology platform personalized treatment for 3,000 cancer patients. Genomic data integrated with clinical records, drug interaction warnings prevented 67 adverse events, and survival rates improved 34%. The AI recommended optimal chemotherapy protocols brilliantly.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'Oncology',
    color: '#8A3FFC',
    impact: '34% survival improvement'
  },
  {
    id: 4,
    name: 'Dr. Robert Martinez',
    role: 'VP of Clinical Operations',
    company: 'Health System Network',
    content: 'Population health management analyzed 250,000 patient records. Risk stratification identified high-risk patients proactively, preventive care interventions reduced hospitalizations 42%, and chronic disease management improved outcomes 67%. Outstanding predictive analytics.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'Population Health',
    color: '#FF3D9A',
    impact: '42% fewer hospitalizations'
  }
];

// Planfusion Testimonials
export const planfusionTestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'David Anderson',
    role: 'Director of PMO',
    company: 'Tech Solutions International',
    content: 'Planfusion revolutionized project management across 45 concurrent projects. AI-powered resource allocation reduced conflicts 78%, timeline predictions achieved 94% accuracy, and project delivery improved 42%. Team collaboration increased dramatically with real-time insights.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'Technology',
    color: '#00CFFF',
    impact: '78% fewer conflicts'
  },
  {
    id: 2,
    name: 'Sarah Mitchell',
    role: 'VP of Operations',
    company: 'Construction Innovations Ltd',
    content: 'Managing $250M construction portfolio became effortless. The platform predicted delays 3 weeks in advance with 91% accuracy, budget variance decreased from 15% to 3%, and stakeholder satisfaction jumped 67%. Best project management tool we ever implemented.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'Construction',
    color: '#0FFFA0',
    impact: '91% delay prediction'
  },
  {
    id: 3,
    name: 'Michael Chen',
    role: 'Chief Strategy Officer',
    company: 'Enterprise Consulting Group',
    content: 'Portfolio optimization with AI recommendations improved ROI 156%. Resource utilization increased from 62% to 89%, cross-project dependencies tracked automatically, and strategic alignment improved 73%. The intelligent insights transformed our decision-making process.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'Consulting',
    color: '#8A3FFC',
    impact: '156% ROI improvement'
  },
  {
    id: 4,
    name: 'Jennifer Roberts',
    role: 'Head of Product Development',
    company: 'Innovation Labs Inc',
    content: 'Planfusion coordinated 12 product development teams seamlessly. Sprint planning time reduced 65%, velocity predictions within 5% accuracy, and time-to-market accelerated 38%. The AI-powered risk detection prevented 23 critical blockers. Game-changing platform.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'Product Development',
    color: '#FF3D9A',
    impact: '38% faster delivery'
  }
];

// PredictiveMaintenance Testimonials
export const predictiveMaintenanceTestimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Robert Johnson',
    role: 'VP of Operations',
    company: 'Manufacturing Solutions Inc',
    content: 'Predictive maintenance transformed our plant operations. The AI detected bearing failures 3 weeks before occurrence with 96% accuracy. Unplanned downtime decreased 72%, maintenance costs reduced 45%, and equipment lifespan extended 28%. ROI achieved in 8 months.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    industry: 'Manufacturing',
    color: '#FF6B35',
    impact: '72% less downtime'
  },
  {
    id: 2,
    name: 'Sarah Martinez',
    role: 'Director of Facilities',
    company: 'Energy Grid Systems',
    content: 'Monitoring 450+ critical assets across 12 power stations became seamless. The platform predicted transformer failures 45 days in advance, prevented 34 catastrophic failures, and optimized maintenance schedules. Annual savings exceeded $3.2M. Game-changing technology.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    industry: 'Energy',
    color: '#00CFFF',
    impact: '$3.2M saved annually'
  },
  {
    id: 3,
    name: 'Michael Chen',
    role: 'Chief Engineer',
    company: 'Aviation Maintenance Corp',
    content: 'Aircraft engine monitoring with vibration analysis and thermal imaging detected anomalies 94% accurately. Maintenance windows optimized around flight schedules, component replacements reduced 38%, and safety compliance improved to 99.8%. Outstanding reliability platform.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    industry: 'Aviation',
    color: '#0FFFA0',
    impact: '94% accuracy'
  },
  {
    id: 4,
    name: 'Jennifer Williams',
    role: 'Operations Manager',
    company: 'Food Processing Industries',
    content: 'Real-time condition monitoring prevented 67 equipment failures across production lines. Predictive alerts enabled just-in-time parts ordering, inventory costs decreased 52%, and production efficiency increased 31%. The platform paid for itself within 6 months.',
    rating: 5,
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces',
    industry: 'Food Processing',
    color: '#8A3FFC',
    impact: '31% efficiency gain'
  }
];